import * as React from 'react';
import Svg, { Rect, Path } from 'react-native-svg';
function SignOut(props) {
    return (<Svg width={32} height={32} viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <Rect width={32} height={32} rx={8} fill="#E7F3FB"/>
      <Path d="M18.766 19.456L22.222 16l-3.456-3.457M22.222 16h-8.296M13.926 22.222h-2.765a1.383 1.383 0 01-1.383-1.383V11.16a1.383 1.383 0 011.383-1.383h2.765" stroke="#3999DE" strokeWidth={1.42222} strokeLinecap="round" strokeLinejoin="round"/>
    </Svg>);
}
export default SignOut;
